export default {
  apiUrl: '//graph.facebook.com',
  fallbackApiUrl: '//pix.wix.com/services/facebook2',
  redirectUrl: 'service-connected.html',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/facebook/settings.js